import React from "react";
import IconLogo from "$/valentine/logo.svg";
import HeartLogo from "$/valentine/heart.svg";

export const slides = [
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme1",
    card: {
      heart: <HeartLogo />,
      title: "The midnight shift coupon",
      description: "A full night’s sleep while you take care of feeding and changing our little one",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme2",
    card: {
      heart: <HeartLogo />,
      title: "A 30 minute pass to vent",
      description: "30 minutes of undivided listening, no advice or fixes",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme3",
    card: {
      heart: <HeartLogo />,
      title: "Home-cooked dinner for 3",
      description: "Just us, a cozy blanket, a rom-com and a clean kitchen",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme4",
    card: {
      heart: <HeartLogo />,
      title: "A guilt-free night out with friends",
      description: "Just like old times, with the baby duties taken care of.",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme2",
    card: {
      heart: <HeartLogo />,
      title: "The guilty pleasure pass",
      description: "Just an entire morning of doing nothing, may be just reading a book or scrolling through reels",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme3",
    card: {
      heart: <HeartLogo />,
      title: "The Gift of Not Having to Plan",
      description: "A massage, romantic dinner or any fun activity planned where I just show up and enjoy.",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme1",
    card: {
      heart: <HeartLogo />,
      title: "One chore-free day",
      description: "a full day off from laundry, dishes, and all other chores",
    },
  },
  {
    formUi: false,
    logo: <IconLogo />,
    heading: "All I want this Valentine’s Day",
    themeClass: "theme2",
    card: {
      heart: <HeartLogo />,
      title: "A Long, Peaceful Shower or Bath",
      description: "No interruptions and maybe a setup with candles and music",
    },
  },
  // {
  //   formUi: true,
  //   logo: <IconLogo />,
  //   heading: "All I want this Valentine’s Day",
  //   themeClass: "theme5",
  //   card: {
  //     heart: <HeartLogo />,
  //     title: "Share one that you have in mind",
  //   },
  // },
];

export const previewSlide = {
  formUi: false,
  logo: <IconLogo />,
  heading: "All I want this Valentine’s Day",
  themeClass: "theme2",
  card: {
    heart: <HeartLogo />,
  },
};
